<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-center mb-3>
          <v-flex xs12 md4 text-xs-center>
            <button class="hvr hvr-scale image-button-m1 ma-2" :class="{'bot-check-vis-cen': mostrarBotones}" @click="mostrarBotones=true">
              <img src="../../assets/Modulo 2/diapositiva-2.png" alt="">
            </button>
          </v-flex>
          <v-flex xs12 md8>
            <div v-if="mostrarBotones" class="animated fadeIn texto1">
              <h2 class="modal-title">SOCIETY OF PETROLEUM ENGINEERS – PETROLEUM RESOURCES MANAGEMENT SYSTEM SPE – PRMS </h2>
              <p>Es el sistema de Gestión de Reecursos Petroleros, y representa el estándar de la industria petrolera como resultado del esfuerzo conjunto de las siguientes asociaciones profesionales: Para conocer en detalle <a href="http://www.spe.org/industry/docs/PRMS_Guidelines_Nov2011.pdf" target="blank">haz clic aquí.</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pb-3 xs12 text-xs-center v-for="i in 5" class="md-flex" :class="i>2?'sm4':'sm6'" :key="'img'+i">
        <div v-if="mostrarBotones" class="animated zoomIn" :class="'dura-'+i">
          <button class="hvr hvr-scale image-button-m2 ma-2" :class="{'bot-check-vis-cen': vistos[i-1]}" @click="modal=true, text=i, $set(vistos,i-1,true)">
            <img :src="require('../../assets/Modulo 1/diapositiva-10-'+ i +'.jpg')" alt="">
          </button>
        </div>
      </v-flex>
    </v-layout>
    <transition name="custom" appear-active-class="animated fadeInUp faster" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
      <p v-if="text == 1" v-focus class="texto1" key="text1"><strong>SOCIETY OF PETROLEUM ENGINEERS – PETROLEUM RESOURCES MANAGEMENT SYSTEM SPE – PRMS</strong><br>Es el sistema de Gestión de Recursos Petroleros, y representa el estándar de la industria petrolera como resultado del esfuerzo conjunto de las siguientes asociaciones profesionales: Para conocer en detalle <a href="https://www.spe.org/en/" target="blank">haz clic aquí.</a></p>
      <p v-if="text == 2" v-focus class="texto1" key="text2"><strong>AMERICAN ASSOCIATION OF PETROLEUM GEOLOGISTS – AAPG</strong><br>Es una organización geológica internacional que incluye entre sus miembros geólogos, geofísicos, directores generales, gerentes, consultores, estudiantes y profesores. Si deseas ampliar la información de esta organización <a href="http://www.aapg.org/" target="blank">haz clic aquí.</a></p>
      <p v-if="text == 3" v-focus class="texto1" key="text3"><strong>WORLD PETROLEUM COUNCIL – WPC</strong><br>Es la única organización que representa globalmente a la comunidad internacional de petróleo y gas. Su propósito es mantener y mejorar las vidas de las personas de todo el mundo. Si deseas ampliar la información de esta organización <a href="http://www.world-petroleum.org/" target="blank">haz clic aquí.</a></p>
      <p v-if="text == 4" v-focus class="texto1" key="text4"><strong>SOCIETY OF PETROLEUM EVALUATION ENGIENEERS – SPEE</strong><br>Es la sociedad que se dedica al desarrollo profesional de los miembros y al avance de la profesión de la ingeniería de Petróleo. Su principal objetivo es la educación del público en el área de las definiciones de reservas de petróleo y gas, las evaluaciones de las reservas, y el valor justo de mercado. Si deseas ampliar la información de esta organización <a href="https://secure.spee.org/" target="blank">haz clic aquí.</a></p>
      <p v-if="text == 5" v-focus class="texto1" key="text5"><strong>SOCIETY OF EXPLORATION GEOPHYSICISTS – SEG</strong><br>La sociedad de Geofísicos de Exploración es una organización si fines de lucro, cuya misión es conectar, inspirar y propulsar las personas y la ciencia de la geofísica. Si deseas ampliar la información de esta organización <a href="https://seg.org/Default.aspx?TabId=176&language=en-US" target=blank>haz clic aquí.</a></p>
    </transition>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 10'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      mostrarBotones: false,
      text: 0,
      dialogos: [
        "Aún encontramos más instituciones que regulan el proceso de reservas y recursos. <span class='instruccion'>Haz clic en SPE – PRMS y después en los isologos.</span>" 
      ],
      vistos: Array(5).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/variables';
.image-button-m2{
  img {
    border: 1px solid $azul;
  }
}
.image-button-m2:hover {
  border-bottom: 4px dotted $azul;
}

@media (min-width: 961px) {
  .md-flex {
    flex-basis: 20%;
  }
}
</style>
